import React, { FC } from 'react'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import AuthenticationContext from '../Authentication/AppContext'
import AuthService from '../Authentication/AuthService'
import { Link } from 'react-router-dom'

const ProtectedButton: FC<any> = (props) => {
  const { userPermissions } = React.useContext(AuthenticationContext)
  const { permissions = ['*'], shouldRender = true, tooltip, tooltipPlacement = 'bottom', href, children, ...remainingProps } = props

  const button = tooltip ? (
    <OverlayTrigger placement={tooltipPlacement} overlay={<Tooltip id='button-tooltip'>{tooltip}</Tooltip>}>
      <Button {...remainingProps}>{children}</Button>
    </OverlayTrigger>
  ) : (
    <Button {...remainingProps}>{children}</Button>
  )

  return <>{shouldRender && AuthService.hasPermission(userPermissions, permissions) && (href ? <Link to={href}>{button}</Link> : button)}</>
}

export default ProtectedButton
